'use strict';
import util from '../util';

function initCrossSellTabs() {
    const KEY = {LEFT:'ArrowLeft',RIGHT:'ArrowRight',HOME:'Home',END:'End',ENTER:'Enter',SPACE:' ',SPACEBAR:'Spacebar'};
    const $regions = $('.cross-sell-tab-wrapper');
    if (!$regions.length) return;

    function getTabs($region) {
        return $region.children('.cross-sell-tabs').find('[role="tab"]');
    }

    function getPanels($region) {
        return $region.find('.tab-panel-content');
    }

    function getSelectedTab($region) {
        return getTabs($region).filter('[aria-selected="true"]').first();
    }

    function getCrossSellId($region) {
        return $region.attr('data-cross-sell-id');
    }

    function clearHeading($region) {
        $region.children('.crosssell-heading').first().text('');
    }

    function updateHeadingFromPanel($region, $panel) {
        const $heading = $region.children('.crosssell-heading').first();
        const $panelHeading = $panel.find('h3.header').first();
        const panelHeadingText = $.trim($panelHeading.html());

        if (!$heading.length || !panelHeadingText) return false;

        $heading.text(panelHeadingText);
        return true;
    }

    function scheduleHeadingUpdate($region, $tab, $panel, attempt) {
        if (!$region.closest('html').length || $tab.attr('aria-selected') !== 'true') return;
        if (updateHeadingFromPanel($region, $panel) || attempt >= 10) return;

        setTimeout(function () {
            scheduleHeadingUpdate($region, $tab, $panel, attempt + 1);
        }, 200);
    }

    function getTabWrapper($tab) {
        return $tab.closest('.tab');
    }

    /**
     * Get the panel associated with a tab.
     *
     * aria-controls is the preferred relationship.
     */
    function getPanel($region, $tab) {
        const panelId = $tab.attr('aria-controls');

        if (panelId) {
            return $region.find('.tab-panel-content').filter(function () {
                return this.id === panelId;
            }).first();
        }

        return $();
    }

    function sanitizeId(value) {
        return String(value || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function getRegionInstanceId($region) {
        const existingId = $region.attr('data-cross-sell-instance');

        if (existingId) return existingId;

        let instanceId = getCrossSellId($region) || 'crosssell';

        instanceId = sanitizeId(instanceId);

        const existingCount = $('.cross-sell-tab-wrapper').filter(function () {
            return $(this).attr('data-cross-sell-instance') === instanceId;
        }).length;

        if (existingCount > 0) instanceId += '-' + (existingCount + 1);

        $region.attr('data-cross-sell-instance', instanceId);

        return instanceId;
    }

    function updateTabAttributes($region) {
        const $tabs = getTabs($region);
        const count = $tabs.length;
        const instanceId = getRegionInstanceId($region);
        const $selected = getSelectedTab($region);
        const selectedTabName = $selected.attr('data-tab');

        if (!$tabs.length) return;

        $tabs.each(function (index) {
            const $tab = $(this);
            const tabName = $tab.attr('data-tab');

            if (!tabName) return;

            const isSelected = selectedTabName ? tabName === selectedTabName : index === 0;
            const safeTabName = sanitizeId(tabName);
            const tabId = instanceId + '-tab-' + safeTabName;
            const panelId = instanceId + '-panel-' + safeTabName;
            const $wrapper = getTabWrapper($tab);
            let $panel = $wrapper.find('.tab-panel-content').first();

            if (!$panel.length) {
                $panel = $region.find('.tab-panel-content[data-panel="' + tabName + '"]').first();
            }

            $tab.attr({
                id: tabId,
                'aria-selected': isSelected ? 'true' : 'false',
                'aria-controls': panelId,
                'aria-setsize': count,
                'aria-posinset': index + 1,
                tabindex: isSelected ? '0' : '-1'
            });

            if ($panel.length) {
                $panel.attr({
                    id: panelId,
                    role: 'tabpanel',
                    'aria-labelledby': tabId,
                    tabindex: '0'
                });
            }
        });
    }

    function updateTabPositions($region) {
        const $tabs = getTabs($region);
        const count = $tabs.length;

        $tabs.each(function (index) {
            $(this).attr({'aria-setsize':count,'aria-posinset':index+1});
        });
    }

    function setRovingTab($region, $tab) {
        const $tabs = getTabs($region);

        $tabs.attr('tabindex', '-1');

        if ($tab && $tab.length) $tab.attr('tabindex', '0');
    }

    function hideAllPanels($region) {
        getPanels($region).attr('hidden', true).removeClass('active-panel');
    }

    function showPanel($region, $tab) {
        hideAllPanels($region);

        const $panel = getPanel($region, $tab);
        const $heading = $region.children('.crosssell-heading').first();
        $heading.text("");
        if ($panel.length) {
            $panel.removeAttr('hidden').addClass('active-panel');
            clearHeading($region);
            scheduleHeadingUpdate($region, $tab, $panel, 0);
            scheduleCategoryBlockReveal($region, $tab, $panel, 0);
        }

        return $panel;
    }

    function scheduleCategoryBlockReveal($region, $tab, $panel, attempt) {
        const $categoryBlock = $region.closest('.category-recommendation-block');

        if (!$categoryBlock.length || !$categoryBlock.attr('hidden')) return;

        if (!$region.closest('html').length || !$tab.closest('html').length) return;

        if ($panel.find('.recommendations-wrapper.recommendation-redesign').length) {
            $categoryBlock.removeAttr('hidden');
            return;
        }

        if (attempt >= 10) return;

        setTimeout(function () {
            scheduleCategoryBlockReveal($region, $tab, $panel, attempt + 1);
        }, 500);
    }

    function clearStatus($region) {
        $region.find('.crosssell-status').text('');
    }

    // Re-announces $message via the region's aria-live status region.
    function announceStatus($region, message) {
        const $status = $region.find('.crosssell-status');

        if (!$status.length || !message) return;

        $status.text('');

        setTimeout(function () {
            $status.text(message);
        }, 50);
    }

    function announceActivation($region, $tab) {
        const label = $.trim($tab.text());
        const position = $tab.attr('aria-posinset');
        const count = $tab.attr('aria-setsize');

        announceStatus($region, label + ', tab, ' + position + ' of ' + count + ', selected');
    }

    function announceLoading($region, $tab) {
        const label = $.trim($tab.text());

        announceStatus($region, label + ' products are loading');
    }

    function activateTab($region, $tab, announce, resetCarouselToFirst) {
        if (!$tab || !$tab.length) return;

        const $tabs = getTabs($region);

        $tabs.attr('aria-selected', 'false').removeClass('active');
        $tab.attr('aria-selected', 'true').addClass('active');

        setRovingTab($region, $tab);

        const $panel = getPanel($region, $tab);

        if (!$panel.length) return;

        const $content = $panel.find('.js-tab-content').first();
        const hasContent = $content.length && $.trim($content.html()).length > 0;

        if (hasContent) {
            // Show panel FIRST so Slick can calculate correct dimensions.
            showPanel($region, $tab);

            // Then initialize/refresh Slick.
            initPanelCarousel($panel);
            refreshPanelCarousel($panel, resetCarouselToFirst);
            // Initialize/refresh product slick AFTER panel is visible
            initProductSlickTrack($panel, $region);
        } else {
            loadTabContent($region, $tab);
        }

        if ($tab[0]) $tab[0].focus();

        if (announce) announceActivation($region, $tab);
    }

    function refreshPanelCarousel($panel, resetToFirst) {
        if (!$panel || !$panel.length) return;
        let $carousel;
        if ($('body').hasClass('suggestions-wrapper_active')) {
            $carousel = $panel.find('.product-suggestion-list').first();
        } else {
            $carousel = $panel.find('#recommendation-slick-carousel .carousel-recommendations').first();
        }

        if (!$carousel.length) return;

        if ($carousel.hasClass('slick-initialized')) {
            if (resetToFirst) {
                $carousel.slick('slickGoTo', 0, true);
            }
            $carousel.slick('setPosition');
        }
    }

    function initProductSlickTrack($panel, $region) {
        if (!$panel || !$panel.length) return;
        const $loader = $region.find('.loading-cross-sell-carousel').first();
        const $tracks = $panel.find('.product-slick-track');

        if (!$tracks.length) return;

        $tracks.each(function () {
            const $track = $(this);

            if ($track.hasClass('slick-initialized')) {
                $track.slick('setPosition');
            } else {
                // Use your existing initialization/configuration here
                $track.slick({
                    initialSlide: 0,
					autoplay: false,
					dots: false,
					arrows: true,
					infinite: false,
					speed: 150,
					slidesToShow: 1,
					fade: true,
                	cssEase: 'linear',
					responsive: [
						{
							breakpoint: 1024,
							settings: {
							arrows: false,
							dots: true,
							}
						}
					]
                });
            }
        });
        if ($(window).width() < 768) {
            $loader.hide();
        }
    }

    function moveFocus($region, direction) {
        const $tabs = getTabs($region);

        if (!$tabs.length) return;

        let $current = $tabs.filter(':focus').first();

        if (!$current.length) $current = getSelectedTab($region);
        if (!$current.length) $current = $tabs.first();

        let currentIndex = $tabs.index($current);

        if (currentIndex === -1) currentIndex = 0;

        let newIndex;

        if (direction === 'next') {
            newIndex = currentIndex + 1;

            if (newIndex >= $tabs.length) newIndex = 0;
        } else {
            newIndex = currentIndex - 1;

            if (newIndex < 0) newIndex = $tabs.length - 1;
        }

        const $target = $tabs.eq(newIndex);

        if (!$target.length) return;

        setRovingTab($region, $target);

        if ($target[0]) $target[0].focus();
    }

    function moveToFirst($region) {
        const $tab = getTabs($region).first();

        if (!$tab.length) return;

        setRovingTab($region, $tab);

        if ($tab[0]) $tab[0].focus();
    }

    function moveToLast($region) {
        const $tab = getTabs($region).last();

        if (!$tab.length) return;

        setRovingTab($region, $tab);

        if ($tab[0]) $tab[0].focus();
    }

    // Initialize region tabs.
    function initializeRegion($region) {
        if (!$region.length) return;

        const crossSellId = getCrossSellId($region);

        if (!crossSellId) return;

        let $tabs = getTabs($region);

        if (!$tabs.length) {
            $region.remove();
            return;
        }

        updateTabAttributes($region);

        if (!$region.closest('html').length) return;

        $tabs = getTabs($region);

        if (!$tabs.length) {
            $region.remove();
            return;
        }

        updateTabPositions($region);

        let $selected = getSelectedTab($region);

        if (!$selected.length) {
            $selected = $tabs.first();

            $tabs.attr('aria-selected', 'false').removeClass('active');
            $selected.attr('aria-selected', 'true').addClass('active');
        } else {
            $tabs.removeClass('active');
            $selected.addClass('active');
        }

        setRovingTab($region, $selected);
        showPanel($region, $selected);

        // Initialize Slick only for the initially visible panel.
        const $selectedPanel = getPanel($region, $selected);

        if ($selectedPanel.length) {
            const $content = $selectedPanel.find('.js-tab-content').first();

            if ($content.length && $.trim($content.html()).length > 0) {
                initPanelCarousel($selectedPanel);
                refreshPanelCarousel($selectedPanel);
            }
        }

        clearStatus($region);
    }

    $regions.off('.crossSellTabs');

    $regions.on('keydown.crossSellTabs', '[role="tab"]', function (event) {
        const $tab = $(this);
        const $region = $tab.closest('.cross-sell-tab-wrapper');
        let key = event.key;

        if (!key) {
            switch (event.which || event.keyCode) {
                case 37: key = KEY.LEFT; break;
                case 39: key = KEY.RIGHT; break;
                case 36: key = KEY.HOME; break;
                case 35: key = KEY.END; break;
                case 13: key = KEY.ENTER; break;
                case 32: key = KEY.SPACE; break;
                default: break;
            }
        }

        switch (key) {
            case KEY.LEFT:
                event.preventDefault();
                event.stopPropagation();
                moveFocus($region, 'previous');
                break;

            case KEY.RIGHT:
                event.preventDefault();
                event.stopPropagation();
                moveFocus($region, 'next');
                break;

            case KEY.HOME:
                event.preventDefault();
                event.stopPropagation();
                moveToFirst($region);
                break;

            case KEY.END:
                event.preventDefault();
                event.stopPropagation();
                moveToLast($region);
                break;

            case KEY.ENTER:
            case KEY.SPACE:
            case KEY.SPACEBAR:
                event.preventDefault();
                event.stopPropagation();
                activateTab($region, $tab, true);
                break;

            default:
                break;
        }
    });

    /*
    * Mouse activation.
    * Everything is scoped to $region.
    * We never use $('.tab-panel-content') here because there
    * can be multiple cross-sell components on the page.
    */
    $regions.on('click.crossSellTabs', '.cs-tab', function (event) {
        const $tab = $(this);
        const $region = $tab.closest('.cross-sell-tab-wrapper');

        event.preventDefault();

        activateTab($region, $tab, true, true);
    });

    // Load panel content when tab is clicked with AJAX call.
    function loadTabContent($region, $tab) {
        const $panel = getPanel($region, $tab);
        const contentUrl = $region.attr('data-content-url');
        const $content = $panel.find('.js-tab-content').first();
        const hasContent = $content.length && $.trim($content.html()).length > 0;
        const contentRequest = $panel.data('contentRequest');

        if (!$content.length) {
            return $.Deferred().resolve().promise();
        }

        if (hasContent) {
            showPanel($region, $tab);
            initPanelCarousel($panel);
            refreshPanelCarousel($panel);
            initProductSlickTrack($panel, $region);

            return $.Deferred().resolve().promise();
        }

        if (!contentUrl) {
            return $.Deferred().resolve().promise();
        }

        // Prevent duplicate AJAX requests.
        if (contentRequest) {
            return contentRequest;
        }

        // Only show the loader if this tab is currently selected.
        const isSelected = $tab.attr('aria-selected') === 'true';
        const $loader = $region.find('.loading-cross-sell-carousel').first();
        if (isSelected) {
            hideAllPanels($region);
            $panel.removeAttr('hidden').addClass('active-panel');
            $loader.show();
            announceLoading($region, $tab);
        }

        $panel.data('contentLoading', true);

        const request = $.ajax({
            url: contentUrl,
            method: 'GET',
            data: {
                panel: $panel.attr('data-panel'),
                type: $panel.attr('data-type')
            }
        }).done(function (html) {
            $content.html(html);

            checkCrossSellContentLoaded($region, $panel, function (isLoaded) {
                if (!isLoaded) {
                    if ($tab.attr('aria-selected') === 'true') {
                        $loader.hide();
                        clearStatus($region);
                    }
                    return;
                }

                // If the user changed tabs while AJAX was running,
                // don't activate this panel.
                const stillSelected = $tab.attr('aria-selected') === 'true';

                if (stillSelected) {
                    showPanel($region, $tab);
                    $loader.hide();
                    clearStatus($region);
                    scheduleCategoryBlockReveal($region, $tab, $panel, 0);
                    scheduleHeadingUpdate($region, $tab, $panel, 0);

                    // IMPORTANT:
                    // The panel is visible before Slick is initialized.
                    initPanelCarousel($panel);
                    refreshPanelCarousel($panel);
                    initProductSlickTrack($panel, $region);
                }
            });
        }).fail(function () {
            if ($tab.attr('aria-selected') === 'true') {
                $loader.hide();
                clearStatus($region);
            }
        }).always(function () {
            $panel.data('contentLoading', false);
            $panel.removeData('contentRequest');
            // DO NOT make the panel visible here.
            // Visibility should only be controlled by showPanel().
        });

        $panel.data('contentRequest', request);
        return request;
    }

    function initPanelCarousel($panel) {
        if (!$panel || !$panel.length) return;

        // Do not initialize carousel for hidden panels.
        if ($panel.attr('hidden') !== undefined || !$panel.hasClass('active-panel')) return;

        if ($(window).width() < 768) {
            initCarouselMobile($panel);
        } else {
            initCarouselDesktop($panel);
        }
    }

    // Check if data is loaded in slot.
    function checkCrossSellContentLoaded($region, $panel, callback) {
        let attempts = 0;

        const maxAttempts = 10;
        const intervalTime = 500;

        const interval = setInterval(function () {
            attempts++;

            const $content = $panel.find('.js-tab-content').first();
            const $recommendationContainer = $content.find('.recommendations-wrapper');
            if ($recommendationContainer.length) {
                clearInterval(interval);

                if (callback) callback(true);

                return;
            }

            if (attempts >= maxAttempts) {
                clearInterval(interval);

                if (callback) callback(false);
            }
        }, intervalTime);
    }

    function loadLazyTabContent() {
        const queue = [];

        $regions.each(function () {
            const $region = $(this);

            getTabs($region).filter('.js-cross-sell-lazyload').each(function () {
                queue.push({
                    $region: $region,
                    $tab: $(this)
                });
            });
        });

        function loadNext() {
            const item = queue.shift();

            if (!item) return;

            loadTabContent(item.$region, item.$tab).always(loadNext);
        }

        loadNext();
    }

    if (document.readyState === 'complete') {
        loadLazyTabContent();
    } else {
        $(window)
            .off('load.crossSellTabsLazyload')
            .one('load.crossSellTabsLazyload', loadLazyTabContent);
    }

    /*
    * Keep the focused tab as the roving tabindex entry point.
    */
    $regions.on('focusin.crossSellTabs', '[role="tab"]', function () {
        const $tab = $(this);
        const $region = $tab.closest('.cross-sell-tab-wrapper');

        setRovingTab($region, $tab);
    });

    /*
    * Restore selected tab as the tablist entry point
    * after focus leaves the component.
    */
    $regions.on('focusout.crossSellTabs', '[role="tab"]', function () {
        const $region = $(this).closest('.cross-sell-tab-wrapper');

        setTimeout(function () {
            if (!$region.closest('html').length) return;

            const $tabs = getTabs($region);

            if (!$tabs.length || $tabs.is(':focus')) return;

            const $selected = getSelectedTab($region);

            if ($selected.length) {
                setRovingTab($region, $selected);
            }
        }, 0);
    });

    /**
     * Refresh all cross-sell components.
     */
    window.refreshCrossSellAccessibility = function () {
        $('.cross-sell-tab-wrapper').each(function () {
            const $region = $(this);

            if (!$region.closest('html').length) return;

            const $tabs = getTabs($region);

            if (!$tabs.length) {
                $region.remove();
                return;
            }

            updateTabAttributes($region);
            updateTabPositions($region);

            let $selected = getSelectedTab($region);

            if (!$selected.length) {
                $selected = $tabs.first();

                $tabs
                    .attr('aria-selected', 'false')
                    .removeClass('active');

                $selected
                    .attr('aria-selected', 'true')
                    .addClass('active');
            } else {
                $tabs.removeClass('active');
                $selected.addClass('active');
            }

            setRovingTab($region, $selected);
            showPanel($region, $selected);
        });
    };

    /*
    * Initialize all cross-sell components independently.
    */
    $regions.each(function () {
        initializeRegion($(this));
    });
}

function initCarouselMobile($panel) {
    if (!$panel || !$panel.length) {
        return;
    }

    const windowWidth = $(window).width();
    let $recommendationSelector;
    $('.popular-search-suggestion .cross-sell-tabs, .popular-search-suggestion .product-suggestion-list').css('width', windowWidth - 10);

    if ($('body').hasClass('suggestions-wrapper_active')) {
        $recommendationSelector = $panel.find('.product-suggestion-list').first();
    } else {
        $recommendationSelector = $panel.find('#recommendation-slick-carousel .carousel-recommendations');
    }

    $panel.find('.recommendation-redesign').closest('.recommendation-block').addClass('re-minheight');

    $panel.find('.recommendation-redesign').closest('.container').addClass('rec-no-padding');

    $recommendationSelector.each(function (index, ele) {
        OverlayScrollbars($(ele), {});
    });

}
function initCarouselDesktop($panel) {
    let showCount;
    let scrollCount;
    let $carouselElement, $carouselSlides;
    const isSuggestionsWrapperActive = $('body').hasClass('suggestions-wrapper_active');
    if (isSuggestionsWrapperActive) {
        showCount = 3;
        scrollCount = 3;
        $carouselElement = $panel.find('.product-suggestion-list').first();
        $carouselSlides = $carouselElement.find('.product-tile-outer');
    } else {
        showCount = 5;
        scrollCount = 4;
        $carouselElement = $panel.find('#recommendation-slick-carousel .carousel-recommendations').first();
    }
    if (!$carouselElement.length) return;
    if (isSuggestionsWrapperActive && $carouselSlides.length <= 3) return;

    if ($carouselElement.hasClass('slick-initialized')) {
        $carouselElement.slick('setPosition');
        return;
    }

    $carouselElement.addClass('slick-pending');

    $carouselElement.not('.slick-initialized').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: showCount,
        slidesToScroll: scrollCount,
        nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
        prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>'
    });

    $carouselElement.slick('setPosition');
    $carouselElement.removeClass('slick-pending');
}
/**
 * Initialize Mini cross sell.
 */
export default {
    init: function () {
        initCrossSellTabs();
    }
};
